module.exports = __webpack_public_path__ + "img/kppKpmKpsKpg.00208c23.png";